import styled from '@emotion/styled';
import {ContentLayerBody as ContentLayerBodyUI} from '@travel-frontend/ui-components';

export const ContentLayerBody = styled(ContentLayerBodyUI)`
  img {
    max-width: 100%;
  }
`;
